export function isBrickFactoryUser(user) {
  return user?.tenant?.businessType === 'brick_factory';
}

export function isBarPubUser(user) {
  const t = user?.tenant?.businessType;
  return t === 'bar_pub' || t === 'bar_pub_with_wakala';
}

export function isPharmacyUser(user) {
  return user?.tenant?.businessType === 'pharmacy';
}

export function isAutomotiveBusiness(user) {
  return user?.tenant?.businessType === 'automotive_products';
}

export function isHardwareBusiness(user) {
  const t = user?.tenant?.businessType;
  return t === 'hardware' || t === 'hardware_with_wakala';
}

/** Shop quotations (product-based) — not for brick factories. */
export function showsShopCustomerDocs(user) {
  if (isBrickFactoryUser(user)) return false;
  const modules = user?.modules;
  if (!Array.isArray(modules)) return true;
  return modules.includes('orders') && !modules.includes('brick');
}

export function tenantDisplayName(user) {
  return user?.tenant?.name || 'your business';
}
